/** Twelve-column layout shared by the header and the rows of the price band table. */
export const PURCHASE_PRICE_BAND_COLUMNS = {
  total: 12,
  bound: 5,
  marginType: 3,
  marginValue: 3,
  action: 1,
} as const;
